import { SQUARE_SHAPE } from '@loggi/ui/components/button/types';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import View from '@loggi/ui/components/view';
import clipartUserBlocked from 'images/user-blocked.png';
import PropTypes from 'prop-types';
import React from 'react';
import WarningScreen from 'shared/warning-screen/warning-screen.component';
import { PATH_PACKAGE_TRACKING } from 'tracker.routes';

export const TITLE = 'Seu acesso foi bloqueado.';

export const PROBLEM_DESCRIPTION =
  'Por motivos de segurança, a gente bloqueou o seu acesso nesse momento. Mas você pode tentar novamente daqui a pouco.';

export const BUTTON_VALUE = 'Acompanhar pedido';

export default function BlockAccessScreen({ history }) {
  const buttonsProps = [
    {
      value: BUTTON_VALUE,
      onClick: () => history.push(PATH_PACKAGE_TRACKING),
      shape: SQUARE_SHAPE
    }
  ];

  return (
    <View className="tracker-content">
      <WarningScreen
        illustration={clipartUserBlocked}
        title={TITLE}
        buttonsProps={buttonsProps}
      >
        <React.Fragment>
          <Text color={colors.type.DARK}>{PROBLEM_DESCRIPTION}</Text>
        </React.Fragment>
      </WarningScreen>
    </View>
  );
}

BlockAccessScreen.displayName = 'BlockAccessScreen';
BlockAccessScreen.propTypes = {
  history: PropTypes.func.isRequired
};
